export default __webpack_public_path__ + "static/media/feature-additional-amentities.f6f695b8.svg";